export const UPDATE_AUDIENCE_LIST_ACTION = 'UPDATE_AUDIENCE_LIST_ACTION';
export const CLEAR_AUDIENCE_LIST_ACTION = 'CLEAR_AUDIENCE_LIST_ACTION';

export const updateList = (data) => {
    return {
        type: UPDATE_AUDIENCE_LIST_ACTION,
        payload: data
    };
}

export const clearList = () => {
    return {
        type: CLEAR_AUDIENCE_LIST_ACTION
    };
}